import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { DepositFormDataService } from '../../deposit-form-data.service';
import { AutoPopulateKeys } from '../../../shared/configurations/auto-populate-keys.config';
import { Subject, takeUntil } from 'rxjs';
import { CustomTranslatePipe } from '../../../shared/pipes/custom-translate.pipe';
import { PlainTextInputComponent } from '../../../parts/plain-text-input/plain-text-input.component';

@Component({
    selector: 'esp-deposit-subtitle',
    templateUrl: './deposit-subtitle.component.html',
    styleUrls: ['./deposit-subtitle.component.scss'],
    imports: [PlainTextInputComponent, CustomTranslatePipe]
})
export class DepositSubtitleComponent implements OnInit, OnDestroy {
  depositFormDataService = inject(DepositFormDataService);

  private subTitleDestroy = new Subject<void>();
  readonly jump = input(undefined);

  ngOnInit() {
    this.onChanges();
  }

  onChanges(): void {
    this.depositFormDataService.subtitle.valueChanges
      .pipe(takeUntil(this.subTitleDestroy))
      .subscribe((value) => {
        if (!this.depositFormDataService.startPopulating) {
          this.depositFormDataService.removeKeyFromAutoPopulatedArray(
            AutoPopulateKeys.SUBTITLE
          );
        }
      });
  }

  get isAutoPopulated() {
    return this.depositFormDataService.isKeyAutoPopulated(
      AutoPopulateKeys.SUBTITLE
    );
  }

  ngOnDestroy() {
    if (!this.subTitleDestroy.isStopped) {
      this.subTitleDestroy.next();
      //unsubscribe from the subject itself
      this.subTitleDestroy.unsubscribe();
    }
  }
}
